/**
 * firestore - データベース情報
 *
 */

//------------
// コレクション名
//------------
export const COLLECTION_USER = "user";
export const COLLECTION_ANALYSIS = "analysis";
export const COLLECTION_GRAPH = "graph";
export const COLLECTION_COMMENT = "comment";
export const COLLECTION_DRAFT = "draft";
export const COLLECTION_FAVORIT = "favorit";

//------------
// フィールド名
//------------
// 分析記事コレクション - 分析記事ドキュメント     @todo 直に記載していいかも
export const FIELD_PERMISSION_USER = "permissionUser";
export const FIELD_PERMISSION_ADMIN = "permissionAdmin";
export const FIELD_CREATE_DATE = "createdAt";
export const FIELD_UPDATE_DATE = "updatedAt";
export const FIELD_DRAFT_UPDATE_DATE = "draftUpdatedAt";
export const FIELD_USER_ID = "userId";

// いいねコレクション - いいねドキュメント
export const FIELD_FAVORIT_USER_ID = "userId";
export const FIELD_FAVORIT_ANALYSIS_ID = "analysisId";
